/** FIREBASE AUTH */
export const AUTH_WATCH = "AUTH_WATCH";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

/** USERS */
export const USERS_WATCH_ON = "USERS_WATCH_ON";
export const USER_CLASSCODE_UPDATE = "USER_CLASSCODE_UPDATE";

/** USERSPUBLIC */
export const USERS_PUBLIC_WATCH_ON = "USERS_PUBLIC_WATCH_ON";
export const USERS_PUBLIC_UPDATE = "USERS_PUBLIC_UPDATE";

/** QUIZ1 */
export const QUIZ1_DATA_WATCH = "QUIZ1_DATA_WATCH";
export const QUIZ1_DATA_UPDATE = "QUIZ1_DATA_UPDATE";

export const QUIZ1_META_WATCH = "QUIZ1_META_WATCH";

/** QUIZ2 */
export const QUIZ2_DATA_WATCH = "QUIZ2_DATA_WATCH";
export const QUIZ2_DATA_UPDATE = "QUIZ2_DATA_UPDATE";

export const QUIZ2_META_WATCH = "QUIZ2_META_WATCH";

/** QUIZ3 */
export const QUIZ3_DATA_WATCH = "QUIZ3_DATA_WATCH";
export const QUIZ3_DATA_UPDATE = "QUIZ3_DATA_UPDATE";

export const QUIZ3_META_WATCH = "QUIZ3_META_WATCH";

/** QUIZ4 */
export const QUIZ4_DATA_WATCH = "QUIZ4_DATA_WATCH";
export const QUIZ4_DATA_UPDATE = "QUIZ4_DATA_UPDATE";

export const QUIZ4_META_WATCH = "QUIZ4_META_WATCH";

/** QUIZ4FEEDBACK */
export const QUIZ4_FEEDBACK_ADD = "QUIZ4_FEEDBACK_ADD";
export const QUIZ4_ONGOING_UPDATE = "QUIZ4_ONGOING_UPDATE";

/** SESSION ACTIONS */
export const SESSION_ADD = "SESSION_ADD";
export const SESSION_WATCH_ON = "SESSION_WATCH_ON";
export const SESSION_WATCH_OFF = "SESSION_WATCH_OFF";

/** CLASS CODE ACTIONS */
export const CLASS_CODE_ADD = "CLASS_CODE_ADD";
export const CLASS_CODE_REMOVE = "CLASS_CODE_REMOVE";
export const CLASS_CODES_WATCH_ON = "CLASS_CODES_WATCH_ON";
export const CLASS_CODES_WATCH_OFF = "CLASS_CODES_WATCH_OFF";

/** LOCATION ACTIONS */
export const LOCATION_UPDATE = "LOCATION_UPDATE";

/** DEBATE ACTIONS */
export const VOTING_OPEN_TOGGLE = "VOTING_OPEN_TOGGLE";

/** EARLY VOTING ACTIONS */
export const AGENDA_ADD = "AGENDA_ADD";
export const EARLY_VOTING_WATCH_ON = "EARLY_VOTING_WATCH_ON";
export const EARLY_VOTING_WATCH_OFF = "EARLY_VOTING_WATCH_OFF";
export const EARLY_VOTING_TARGET_UPDATE = "EARLY_VOTING_TARGET_UPDATE";

/** FINAL VOTING ACTIONS */
export const FINAL_VOTING_WATCH_ON = "FINAL_VOTING_WATCH_ON";
export const FINAL_VOTING_WATCH_OFF = "FINAL_VOTING_WATCH_OFF";
export const FINAL_VOTING_TARGET_UPDATE = "FINAL_VOTING_TARGET_UPDATE";

/** AWARDS ACTIONS */
export const AWARDS_WATCH_ON = "AWARDS_WATCH_ON";
export const AWARDS_WATCH_OFF = "AWARDS_WATCH_OFF";

/** FEEDBACK ACTIONS */
export const FEEDBACK_WATCH_ON = "FEEDBACK_WATCH_ON";
export const FEEDBACK_WATCH_OFF = "FEEDBACK_WATCH_OFF";
